import { Component, OnInit, OnDestroy } from '@angular/core';
import { VendorService } from '../../../../../services/vendor.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../../shared-components/busy-indicator/busy-indicator.component';
import { VendorInfo } from '../../../../../models/VendorInfo';
import { Code } from '../../../../../models/Code';
import { AdminService } from '../../../../../services/Admin.service';
import { SucessMessage } from '../../../../../models/SucessMessage';

@Component({
  selector: 'app-update-contact',
  templateUrl: './update-contact.component.html',
  styleUrls: ['./update-contact.component.scss']
})
export class UpdateContactComponent implements OnInit, OnDestroy {
  public GPVID: string;
  public contactView: VendorInfo = new VendorInfo();
  public addressCode: string;
  public successMsg: string;
  public errorMsg: string;
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;
  public stateList: Code[];
  public countryList: Code[];
  public successMessage: SucessMessage;
  private alive = true;
  constructor(private vendorSvc: VendorService,
  private router: Router,
  private route: ActivatedRoute,
  private spinner: NgxSpinnerService) {
    this.route.queryParams
        .takeWhile(() => this.alive)
        .subscribe( params => {
          this.GPVID = params['GPVID'];
          this.addressCode = params['addressCode'];
        });
  }

  ngOnInit() {
    this.getCountryList();
    this.getStateList();
    this.getVedorContact();
  }

  getCountryList() {
    this.vendorSvc.getCountryList()
    .takeWhile(() => this.alive)
    .subscribe(data => {
        this.countryList = data;
        this.showFailConfirmation = false;
        this.showSuccessConfirmation = false;
      },
      err => {
        this.successMsg = null;
        this.errorMsg = err;
        this.showFailConfirmation = true;
        this.showSuccessConfirmation = false;
      }
    );
  }

  getStateList() {
    this.vendorSvc.getStateList()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.stateList = data;
      this.showFailConfirmation = false;
      this.showSuccessConfirmation = false;
      },
      err => {
        this.successMsg = null;
        this.errorMsg = err;
        this.showFailConfirmation = true;
        this.showSuccessConfirmation = false;
      }
    );
  }

  getVedorContact() {
    this.vendorSvc.getVendorContactByAddressCode(this.GPVID, this.addressCode)
    .takeWhile(() => this.alive)
    .subscribe(data => {
        this.contactView = data;
        if (!this.contactView) {
          this.contactView = new VendorInfo();
          this.contactView.GPVID = this.GPVID;
          this.contactView.AddressCode = this.addressCode;
        }
        this.showFailConfirmation = false;
        this.showSuccessConfirmation = false;
      },
      err => {
        this.successMsg = null;
        this.errorMsg = err;
        this.showFailConfirmation = true;
        this.showSuccessConfirmation = false;
      }
    );
  }

  onSubmit(frmUpdateContact: NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();
    this.vendorSvc.updateVendorContact(this.contactView)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
                this.spinner.hide();
                this.successMessage = data;
                this.errorMsg = null;
                this.successMsg = this.successMessage.Message;
                this.showSuccessConfirmation = true;
                this.showFailConfirmation = false;
          },
      err => {
          this.spinner.hide();
          this.successMsg = null;
          this.errorMsg = err;
          this.showSuccessConfirmation = false;
          this.showFailConfirmation = true;
        }
    );
   // window.scrollTo(0, 0);
  }

  onCancel() {
    this.router.navigate([`/pages/vendor/myvendor/vendorcontacts`]);
  }

  redirectTo(event) {
    this.router.navigate([`/pages/vendor/myvendor/vendorcontacts`]);
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/vendor-contact/update-contact/update-contact.component.ts